export interface NetworkTypeResult {
  type: string;
  effectiveType: string | null;
  downlink: number | null;
  rtt: number | null;
  saveData: boolean;
}

export function detectNetworkType(): NetworkTypeResult {
  const conn = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;

  if (!conn) {
    const isSecure = location.protocol === "https:" || location.hostname === "localhost";
    return {
      type: isSecure ? "unsupported" : "requires-https",
      effectiveType: null,
      downlink: null,
      rtt: null,
      saveData: false,
    };
  }

  return {
    type: conn.type || "unknown",
    effectiveType: conn.effectiveType || null,
    downlink: conn.downlink ?? null,
    rtt: conn.rtt ?? null,
    saveData: conn.saveData || false,
  };
}
